import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "product-cards" }
const _hoisted_2 = {
  key: 0,
  class: "row"
}
const _hoisted_3 = { class: "col col-shrink" }
const _hoisted_4 = {
  key: 1,
  class: "row"
}
const _hoisted_5 = { class: "col" }
const _hoisted_6 = { class: "col col-shrink" }
const _hoisted_7 = { class: "pagination-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_no_data_img = _resolveComponent("no-data-img")!
  const _component_product_card = _resolveComponent("product-card")!
  const _component_product_card_variant = _resolveComponent("product-card-variant")!
  const _component_chevron_down_icon = _resolveComponent("chevron-down-icon")!
  const _component_chevron_up_icon = _resolveComponent("chevron-up-icon")!
  const _component_q_pagination = _resolveComponent("q-pagination")!
  const _component_filterable_list = _resolveComponent("filterable-list")!
  const _component_add_products_dialog = _resolveComponent("add-products-dialog")!
  const _component_add_variants_dialog = _resolveComponent("add-variants-dialog")!
  const _component_link_product_dialog = _resolveComponent("link-product-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_filterable_list, {
      editing: _ctx.editing,
      expanded: _ctx.expanded,
      onAdd: _cache[6] || (_cache[6] = ($event: any) => (_ctx.addingProducts.show = true)),
      onCancel: _ctx.cancelEditing,
      onSave: _ctx.save,
      "filter-values": _ctx.filterValues,
      "search-value": _ctx.searchQuery,
      "onUpdate:searchValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.searchQuery) = $event)),
      "filter-value": _ctx.filterValue,
      "onUpdate:filterValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.filterValue) = $event)),
      ref: "filterableList",
      readonly: _ctx.readonly
    }, {
      "filterable-list": _withCtx(() => [
        (!_ctx.filteredCatalogueProducts?.length && _ctx.pageSize)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "empty-placeholder cursor-pointer",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addingProducts.show = true))
            }, [
              _createVNode(_component_no_data_img),
              _cache[12] || (_cache[12] = _createElementVNode("h5", { class: "text-align-center" }, [
                _createElementVNode("span", null, "This Channel has no products yet. "),
                _createElementVNode("span", { class: "highlight underline" }, "Add some")
              ], -1))
            ]))
          : _createCommentVNode("", true),
        (!_ctx.pageSize)
          ? (_openBlock(), _createBlock(_component_product_card, {
              key: 1,
              class: "dummy-card",
              ref: "dummyCard"
            }, null, 512))
          : _createCommentVNode("", true),
        _createElementVNode("section", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredCatalogueProducts.slice(0, !_ctx.expanded ? Math.min(_ctx.pageSize ?? 0, 6) : undefined), (product) => {
            return (_openBlock(), _createBlock(_component_product_card, {
              variants: _ctx.catalogueVariants[product.id] ?? [],
              "cat-product": product,
              product: _ctx.products.find(p => p.sys.id === product.id),
              "sku-controller": _ctx.skuController,
              "variant-dialog-active": _ctx.addingVariants.catProdId,
              "onUpdate:variantDialogActive": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.addingVariants.catProdId) = $event)),
              "link-dialog-active": _ctx.linkingProduct.catProdId,
              "onUpdate:linkDialogActive": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.linkingProduct.catProdId) = $event)),
              "onUpdate:catProduct": _ctx.updateProduct,
              onExpand: ($event: any) => (_ctx.expandProduct(product, $event)),
              onCancel: ($event: any) => (_ctx.cancelProduct(product.sys.id)),
              onRemoveProduct: ($event: any) => (_ctx.removeProduct(product, $event)),
              key: product.sys.id,
              "is-linked-to-shopify": _ctx.isLinkedToShopify,
              "store-url": _ctx.storeUrl,
              readonly: _ctx.readonly
            }, {
              variants: _withCtx(({ productVariants }) => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productVariants, (variant) => {
                  return (_openBlock(), _createBlock(_component_product_card_variant, {
                    key: `${variant.sys.id}-${product.sys.id}`,
                    "catalogue-variant": variant,
                    "onUpdate:catalogueVariant": _ctx.updateVariant,
                    product: _ctx.products.find(p => p.sys.id === variant.id),
                    catalogue: _ctx.catalogue,
                    editing: _ctx.editing,
                    "onUpdate:editing": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.editing) = $event)),
                    onAddVariant: ($event: any) => (_ctx.addVariant(product)),
                    readonly: _ctx.readonly
                  }, null, 8, ["catalogue-variant", "onUpdate:catalogueVariant", "product", "catalogue", "editing", "onAddVariant", "readonly"]))
                }), 128))
              ]),
              _: 2
            }, 1032, ["variants", "cat-product", "product", "sku-controller", "variant-dialog-active", "link-dialog-active", "onUpdate:catProduct", "onExpand", "onCancel", "onRemoveProduct", "is-linked-to-shopify", "store-url", "readonly"]))
          }), 128))
        ])
      ]),
      after: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass(["show-more-products", {expanded: _ctx.expanded}]),
          ref: "showMoreProducts"
        }, [
          (_ctx.expandable && !_ctx.expanded)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _cache[14] || (_cache[14] = _createElementVNode("div", { class: "col" }, null, -1)),
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", {
                    class: "title-container",
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.toggleExpand && _ctx.toggleExpand(...args)))
                  }, [
                    _createVNode(_component_chevron_down_icon, {
                      class: "q-mr-sm",
                      color: "primary"
                    }),
                    _cache[13] || (_cache[13] = _createElementVNode("div", { class: "title" }, "Show more products", -1))
                  ])
                ]),
                _cache[15] || (_cache[15] = _createElementVNode("div", { class: "col" }, null, -1))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  (_ctx.expandable)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "title-container q-mr-auto",
                        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.toggleExpand && _ctx.toggleExpand(...args)))
                      }, [
                        _createVNode(_component_chevron_up_icon, {
                          class: "q-mr-sm",
                          color: "primary"
                        }),
                        _cache[16] || (_cache[16] = _createElementVNode("div", { class: "title" }, "Show less products", -1))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_q_pagination, {
                      "model-value": _ctx.currentPage || 1,
                      "onUpdate:modelValue": _ctx.setPage,
                      max: _ctx.pageCount || 1,
                      input: "",
                      "direction-links": "",
                      unelevated: ""
                    }, null, 8, ["model-value", "onUpdate:modelValue", "max"])
                  ])
                ]),
                _cache[17] || (_cache[17] = _createElementVNode("div", { class: "col" }, null, -1))
              ])),
          _cache[18] || (_cache[18] = _createElementVNode("div", { class: "divider" }, null, -1))
        ], 2)
      ]),
      _: 1
    }, 8, ["editing", "expanded", "onCancel", "onSave", "filter-values", "search-value", "filter-value", "readonly"]),
    _createVNode(_component_add_products_dialog, {
      show: _ctx.addingProducts.show,
      "onUpdate:show": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.addingProducts.show) = $event)),
      "draft-product-ids": _ctx.addingProducts.draftProductIds,
      "catalogue-id": _ctx.catalogue.sys.id,
      onAddProducts: _ctx.addingProducts.addProducts
    }, null, 8, ["show", "draft-product-ids", "catalogue-id", "onAddProducts"]),
    _createVNode(_component_add_variants_dialog, {
      ref: "addVariantsDialog",
      "catalogue-product-id": _ctx.addingVariants.catProdId,
      "onUpdate:catalogueProductId": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.addingVariants.catProdId) = $event)),
      "product-id": _ctx.addingVariants.prodId,
      "current-variants": _ctx.addingVariants.currentVariants,
      catalogue: _ctx.catalogue,
      onAddVariants: _ctx.addingVariants.addVariants
    }, null, 8, ["catalogue-product-id", "product-id", "current-variants", "catalogue", "onAddVariants"]),
    _createVNode(_component_link_product_dialog, {
      ref: "linkProductDialog",
      "catalogue-product-id": _ctx.linkingProduct.catProdId,
      "onUpdate:catalogueProductId": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.linkingProduct.catProdId) = $event)),
      "current-products": _ctx.linkingProduct.currentProducts,
      catalogue: _ctx.catalogue,
      onLinkProduct: _ctx.linkingProduct.linkProduct
    }, null, 8, ["catalogue-product-id", "current-products", "catalogue", "onLinkProduct"])
  ], 64))
}